import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVeryHappyEmotion = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#FFB03D" d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10" />
    <path
      fill="#00265D"
      stroke="#00265D"
      strokeWidth={0.043}
      d="M8.802 7.21a.33.33 0 0 1-.02.196.2.2 0 0 1-.118.093.6.6 0 0 1-.206.021 2 2 0 0 1-.272-.032q-.143-.025-.302-.058l-.012-.003q-.163-.035-.332-.063a2 2 0 0 0-.631-.032c-.193.03-.404.118-.611.221a11 11 0 0 0-.323.17q-.143.079-.276.147-.139.07-.258.113a.6.6 0 0 1-.207.043.2.2 0 0 1-.14-.053c-.034-.036-.06-.093-.072-.181-.048-.353.158-.749.5-1.07s.816-.563 1.294-.609c.443-.042.916.055 1.291.252s.647.492.695.844ZM11.345 7.21a.33.33 0 0 0 .021.196.2.2 0 0 0 .118.093.6.6 0 0 0 .205.021q.124-.006.272-.032.144-.025.302-.058l.012-.003q.164-.035.332-.063c.222-.038.443-.06.632-.032.193.03.403.118.61.221q.157.08.309.163l.014.008q.144.077.276.146.14.07.258.113a.6.6 0 0 0 .207.043.2.2 0 0 0 .14-.053c.035-.036.061-.093.073-.181.048-.353-.158-.749-.5-1.07-.343-.321-.817-.563-1.295-.609a2.4 2.4 0 0 0-1.29.252c-.376.197-.648.492-.696.844Z"
    />
    <path
      fill="#00265D"
      stroke="#00265D"
      strokeLinecap="round"
      strokeWidth={1.176}
      d="M10 15.294c-2.51 0-4.049-1.749-4.537-2.404-.073-.097.004-.226.125-.215.778.074 2.927.266 4.412.266s3.634-.192 4.411-.266c.121-.011.198.118.126.215-.489.655-2.027 2.403-4.537 2.403Z"
    />
  </svg>
);
export default SvgVeryHappyEmotion;
